import { Space } from "antd";
import styled from "styled-components";

export const DropdownWrapper = styled(Space)`
  .ant-select-selector {
    border: ${(props) =>
      props.allowborder ? "1px solid #DDE2E9" : "0px !important"};
    box-shadow: none !important;
  }
  .ant-select-selector:hover {
    background: #f3f4f7 !important;
    border: ${(props) =>
      props.allowborder ? "1px solid #DDE2E9 !important" : "0px !important"};
  }
  .ant-select-selection-item {
    color: #48566b !important;
    font-family: 'Manrope', sans-serif;
    font-weight: 500;
    font-size: 13px;
    leading-trim: Cap height;
    line-height: 100%;
    letter-spacing: 0%;
  }
  .ant-select-selector.ant-select-dropdown {
    width: 200px !important;
  }
  .dropdown-container {
    .ant-select-dropdown {
      background: yellow !important;
      width: 200px !important;
    }
  }

  ${(props) =>
    props.pagination &&
    `
  .ant-select {
    height: 24px !important;
    border-color: #d9d9d9;

    .ant-select-selector {
      height: 24px !important;
      padding: 0 4px !important;
      display: flex;
      align-items: center;
    }

    .ant-select-selector:hover {
      border-color: #d9d9d9;
    }

    .ant-select-selection-item {
      font-size: 12px !important;
      line-height: 24px;
      padding-inline-end: 12px!important;
    }

    /* shrink the default arrow only for pagination */
    .ant-select-arrow {
      font-size: 8px !important;
      width: 10px;
      height: 12px;
      right: 4px;
    }
  }
`}

`;
